site.examCounter = {
	init: function () {
		let $examAnswerForm = $('#btwExamAnswer');
		if (!$examAnswerForm.length) {
			return;
		}

		site.examCounter.appendCustom();
		let $body = $('body');
		if(!$body.is('.btwFront')) {
			return;
		}
		site.examCounter.fixes();

		var $checkBoxesFieldset = $('fieldset.checkboxes');
		var $checkBoxes = $('input[type="checkbox"]', $checkBoxesFieldset);
		var $counterWrap = $('#elm_count');
		var $counter = $('#elm_count span');
		var totalCount = $counterWrap.attr('data-totalcount');
		var $imageWrap = $('#topContent .examImageWrap');
		$('#elm_label').append($counterWrap);
		$checkBoxesFieldset.wrapInner('<div class="wrap" />');
		$checkBoxesFieldset.append($imageWrap);

		if($checkBoxes.filter(':checked').length !== totalCount) {
			$('#submitForm').addClass('disabled');
		}

		$checkBoxes.change(function(){
			$counter.text($checkBoxes.filter(':checked').length);

			if (parseInt($counter.text()) >= parseInt(totalCount)) {
				$('#elm_controls #submitForm').removeClass('disabled');

				if ($counterWrap.hasClass('second')) {
					$('input[type=checkbox]:not(:checked)', '.elm_multiCheckbox').each(function () {
						$(this).parent().addClass('disabled');
						$(this).attr('disabled', true);
					});
				}
			}
			else {
				$('#elm_controls #submitForm').addClass('disabled');

				if ($counterWrap.hasClass('second')) {
					$('input[type=checkbox]:disabled', '.elm_multiCheckbox').each(function () {
						$(this).parent().removeClass('disabled');
						$(this).attr('disabled', false);
					});
				}
			}
		});

		$('a.childToggle').on('click', function(e) {
			e.preventDefault();
			$(this).closest('fieldset').toggleClass('open');
		});

		site.maxHeight.init('fieldset.group');
		setInterval(function() {
			$(window).trigger('resize');
		}, 2000);
	},

	appendCustom: function() {
		let $customText = $('input.customText');
		$customText.each(function() {
			let $this = $(this);
			let name = $this.attr('name');
			$this.insertAfter($('#first-' + name));
		});

		$customText.on('input', function() {
			let $checkbox = $(this).prev();
			if (!$checkbox.is(':checked')) {
				$(this).prev().trigger('click');
			}
		});
	},

	fixes: function() {
		$('#elm_subTitle').prependTo('#topContent .boxTitle');
		$('#cancel').removeAttr('onclick').on('click', function() {
			$('button.close').trigger('click');
		});
	}
};